export interface AssessmentResultTranslations {
  assessmentSelectorLabel: {
    forPatient: string;
    forNonPatient: string;
  };
  print: string;
  scrollToTheTop: string;
  tabs: {
    overall: string;
    subscales: string;
  };
  score: {
    label: string;
    outOf: string;
    title: {
      forPatient: string;
      forNonPatient: string;
    };
  };
  chart: {
    title: string;
    dataset1: {
      label: {
        forPatient: string;
        forNonPatient: string;
      };
    };
  };
  table: {
    assessmentResponses: string;
    noResults: string;
    loading: string;
    col1CoreMeasures: string;
    col1NonCoreMeasures: string;
    col2CoreMeasures: string;
    multiSelect: {
      selected: string;
    };
  };
  subscales: {
    subscaleSelectorLabel: string;
    subscaleSelectorPlaceholder: string;
  };
  moreToDoItems: {
    description: string;
    continueButton: string;
  };
}

export const assessmentResultTranslationKeys: AssessmentResultTranslations = {
  assessmentSelectorLabel: {
    forPatient: 'assessmentSelectorLabel.forPatient',
    forNonPatient: 'assessmentSelectorLabel.forNonPatient',
  },
  print: 'print',
  scrollToTheTop: 'scrollToTheTop',
  tabs: {
    overall: 'tabs.overall',
    subscales: 'tabs.subscales',
  },
  score: {
    label: 'score.label',
    outOf: 'score.outOf',
    title: {
      forPatient: 'score.title.forPatient',
      forNonPatient: 'score.title.forNonPatient',
    },
  },
  chart: {
    title: 'chart.title',
    dataset1: {
      label: {
        forPatient: 'chart.dataset1.label.forPatient',
        forNonPatient: 'chart.dataset1.label.forNonPatient',
      },
    },
  },
  table: {
    assessmentResponses: 'table.assessmentResponses',
    noResults: 'table.noResults',
    loading: 'table.loading',
    col1CoreMeasures: 'table.col1CoreMeasures',
    col1NonCoreMeasures: 'table.col1NonCoreMeasures',
    col2CoreMeasures: 'table.col2CoreMeasures',
    multiSelect: {
      selected: 'table.multiSelect.selected',
    },
  },
  subscales: {
    subscaleSelectorLabel: 'subscales.subscaleSelectorLabel',
    subscaleSelectorPlaceholder: 'subscales.subscaleSelectorPlaceholder',
  },
  moreToDoItems: {
    description: 'moreToDoItems.description',
    continueButton: 'moreToDoItems.continueButton',
  },
};

export const assessmentResultTranslationsEN: AssessmentResultTranslations = {
  assessmentSelectorLabel: {
    forPatient: 'Select an Assessment',
    forNonPatient: 'Comparison Assessment',
  },
  print: 'Print',
  scrollToTheTop: 'Scroll to the Top',
  tabs: {
    overall: 'Overall',
    subscales: 'Subscales',
  },
  score: {
    label: 'Score:',
    outOf: 'out of',
    title: {
      forPatient: 'Score',
      forNonPatient: 'Scores',
    },
  },
  chart: {
    title: 'Score',
    dataset1: {
      label: {
        forPatient: 'Score',
        forNonPatient: 'Patient',
      },
    },
  },
  table: {
    assessmentResponses: 'Assessment Responses',
    noResults: 'No assessment result found.',
    loading: 'Loading...',
    col1CoreMeasures: 'Data Element',
    col1NonCoreMeasures: 'Question',
    col2CoreMeasures: 'Response',
    multiSelect: {
      selected: 'Yes',
    },
  },
  subscales: {
    subscaleSelectorLabel: 'Jump to...',
    subscaleSelectorPlaceholder: 'Select a Subscale',
  },
  moreToDoItems: {
    description: 'You have more To-Do items remaining',
    continueButton: 'Continue with the next assessment',
  },
};

export const assessmentResultTranslationsES: AssessmentResultTranslations = {
  assessmentSelectorLabel: {
    forPatient: 'Seleccionar una evaluación',
    forNonPatient: 'Evaluación de comparación',
  },
  print: 'Imprimir',
  scrollToTheTop: 'Ir al principio',
  tabs: {
    overall: 'General',
    subscales: 'Subescalas',
  },
  score: {
    label: 'Puntuación:',
    outOf: 'de',
    title: {
      forPatient: 'Puntuación',
      forNonPatient: 'Puntuaciones',
    },
  },
  chart: {
    title: 'Puntuación',
    dataset1: {
      label: {
        forPatient: 'Puntuación',
        forNonPatient: 'Paciente',
      },
    },
  },
  table: {
    assessmentResponses: 'Respuestas de la evaluación',
    noResults: 'No se encontraron resultados de la evaluación.',
    loading: 'Cargando...',
    col1CoreMeasures: 'Elemento de datos',
    col1NonCoreMeasures: 'Medidas no centrales',
    col2CoreMeasures: 'Respuesta',
    multiSelect: {
      selected: 'Sí',
    },
  },
  subscales: {
    subscaleSelectorLabel: 'Saltar a...',
    subscaleSelectorPlaceholder: 'Seleccionar una subescala',
  },
  moreToDoItems: {
    description: 'Tienes más tareas pendientes',
    continueButton: 'Continuar con la siguiente evaluación',
  },
};
